import { create } from "zustand";
import { persist } from "zustand/middleware";

/**
 * Light, dark, or the device's own setting (Olivia, 10 Oct). Shared by the
 * phone's Appearance row and the desktop's one-click switch, which sets Light
 * or Dark explicitly. `null`: never chosen — a phone follows the system, the
 * desktop keeps the theme it has.
 */
export type Appearance = "system" | "light" | "dark";

interface AppearanceState {
  appearance: Appearance | null;
  setAppearance: (a: Appearance) => void;
}

export const useAppearanceStore = create<AppearanceState>()(
  persist((set) => ({ appearance: null, setAppearance: (appearance) => set({ appearance }) }), { name: "lilia.appearance" }),
);

/** What the system asks for now. */
export function systemTheme(): "light" | "dark" {
  return typeof window !== "undefined" && window.matchMedia?.("(prefers-color-scheme: dark)").matches ? "dark" : "light";
}
